module.exports = __webpack_public_path__ + "img/brand4.06f87e7a.png";